import Carousel from "../../Atoms/Carousel";
import Tour from "../Tour";

interface Props {
  items: Array<any>;
  linkRef: string;
}

export default function ProductCarousel({ items, linkRef }: Props) {
  if (items.length < 1) return null;

  return (
    <Carousel
      gutter={20}
      items={items.map((product, index) => (
        <Tour
          key={index}
          parameter={linkRef}
          id={product.id}
          tags={product.tags}
          translation={product.translation}
          poster={product.poster}
          price={product.price}
          reviews={product.reviews}
          duration={product.duration}
        />
      ))}
    />
  );
}
